// ============================================================
// ENGINE DECISION BUILDER
// ============================================================

export function decision({

    generate = false,

    code,

    reason,

    dueDate = null,

    nextGeneration = null,

    details = {}

}) {

    return {

        generate,

        code,

        reason,

        dueDate,

        nextGeneration,

        details

    }

}